import React from 'react';
import styled from 'styled-components';
import { IconVerfied } from '@prisjakt/ui/icon';

export const CORNER_BADGE_SIZE = 16;

type Props = { className?: string };

export const CornerBadge = (props: Props) => {
  return (
    <Wrapper className={props.className}>
      <Badge color="yellove900" size={CORNER_BADGE_SIZE} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  clip-path: polygon(0% 100%, 100% 0%, 0% 0%);
  background: ${p => p.theme.colors.yellove500};
  border-top-left-radius: 8px;
`;

const Badge = styled(IconVerfied)`
  margin-top: 2px;
  margin-left: 2px;
`;
